export default __webpack_public_path__ + "static/bg-dfb4e4478e746401a6cb0f0c8f51c56e.png";